import { createSlice } from '@reduxjs/toolkit';
import { Organization } from '@src/components/Branch/Branch';

interface OrganizationState {
	value: Organization | {};
}

const initialState: OrganizationState = {
	value: {},
};

export const organizationSlice = createSlice({
	name: 'organization',
	initialState,
	reducers: {
		setUsersOrganization: (state, organization) => {
			state.value = organization.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setUsersOrganization } = organizationSlice.actions;

export default organizationSlice.reducer;
